import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFlipHorizontally12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconFlipHorizontally12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="m2.551 9.997 7-.723A.5.5 0 0 0 10 8.777v-1.22l1-.004v1.224a1.5 1.5 0 0 1-1.346 1.492l-7 .723A1.5 1.5 0 0 1 1 9.5V7.596l1-.004V9.5a.5.5 0 0 0 .551.497M11 4.452h-1V3.223a.5.5 0 0 0-.449-.497l-7-.723A.5.5 0 0 0 2 2.5v1.952H1V2.5a1.5 1.5 0 0 1 1.654-1.492l7 .723A1.5 1.5 0 0 1 11 3.223zm.5 2.057a.5.5 0 0 0 0-1H.525a.5.5 0 1 0 0 1z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconFlipHorizontally12);
